import { DownloadIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from '@chakra-ui/react'

import { useLocalRecording } from '@/react-query/local-recording'
import { ArrowSvg } from '@/views/assets/ArrowSvg'
import { DeleteIcon } from '@/views/assets/DeleteIcon'
import { MicrophoneIcon } from '@/views/assets/MicrophoneIcon'
import { TabIcon } from '@/views/assets/TabIcon'

import { useAudioRecorder } from '../../../../context/AudioRecorderContext/AudioRecorderContext'
import { RecordingSource } from '../../../../context/AudioRecorderContext/types'
import { downloadAudioFile } from '../../../../utils/downloadAudioFile'

import { DiscardConfirmationModal } from './DiscardConfirmationModal'

const formatRecordingStartTime = (
  timestamp: string | number | Date,
): string => {
  const date = new Date(timestamp)
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

export const ExistingRecording = () => {
  const { data: recording } = useLocalRecording()
  const {
    isOpen: isDiscardModalOpen,
    onOpen: onDiscardModalOpen,
    onClose: onDiscardModalClose,
  } = useDisclosure()

  const {
    uploadExistingRecording,
    startMicrophoneRecording,
    startTabRecording,
  } = useAudioRecorder()

  if (!recording) {
    return null
  }

  return (
    <>
      <Flex>
        <Menu>
          <MenuButton
            as={Button}
            variant={'brand-solid-white'}
            rightIcon={<ArrowSvg />}
          >
            {recording.source === RecordingSource.MIC
              ? 'Microphone recording'
              : 'Browser tab recording'}{' '}
            {formatRecordingStartTime(recording.recordingStartTime)}
          </MenuButton>

          <MenuList>
            <>
              <MenuItem
                onClick={() => startMicrophoneRecording({ isResume: true })}
                pr={6}
                px={5}
                className="!pt-4"
              >
                <MicrophoneIcon width="20px" height="21px" />
                <Box ml={3}>Continue via microphone</Box>
              </MenuItem>

              <MenuItem
                onClick={() => startTabRecording({ isResume: true })}
                pr={6}
                px={5}
              >
                <TabIcon width="20px" height="20px" />
                <Box ml={3}>Continue via tab</Box>
              </MenuItem>

              <MenuItem onClick={uploadExistingRecording} pr={6} px={5}>
                <DownloadIcon
                  width="20px"
                  height="20px"
                  transform="rotate(180deg)"
                />
                <Box ml={3}>Finish and upload</Box>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  downloadAudioFile({
                    chunks: recording?.chunks || [],
                    mimeType: recording?.mimeType || 'audio/webm;codecs=opus',
                    source: recording?.source || RecordingSource.MIC,
                  })
                }}
                pr={6}
                px={5}
              >
                <DownloadIcon width="20px" height="20px" />
                <Box ml={3}>Download file</Box>
              </MenuItem>

              <MenuItem
                onClick={onDiscardModalOpen}
                pr={6}
                px={5}
                color={'red.500'}
              >
                <DeleteIcon width="20px" height="20px" color={'red.500'} />
                <Box ml={3}>Discard</Box>
              </MenuItem>
            </>
          </MenuList>
        </Menu>
      </Flex>
      <DiscardConfirmationModal
        isOpen={isDiscardModalOpen}
        onClose={onDiscardModalClose}
      />
    </>
  )
}
